import lodashCapitalize from 'lodash-es/capitalize';

export const capitalize = (str?: string | null) => {
  return lodashCapitalize(str ?? '').replace(/\b(c|C)bd\b/g, 'CBD');
};

export const capitalizeEveryWord = (str?: string | null) => {
  return (str ?? '').split(' ').map(capitalize).join(' ');
};
